import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { GorevEditComponent } from './gorev-edit.component';
import { GorevKartComponent } from './gorev-kart.component';

@DinamikBilesen({
  id: 'gorev',
  baslik: 'Görev',
  aciklama: 'Görev / checklist kalemi',
  ikon: 'check-square',
  kategori: 'bakim',
})
class Gorev {
  paylas_kutusu = GorevEditComponent;
  paylasilmis_kart = GorevKartComponent;
}
